import {
  bindGlobalSearchActions,
  buildGlobalSearchView,
  createGlobalSearchRuntime,
} from '~/composables/search/globalSearchController'

export function useGlobalSearch() {
  const runtime = createGlobalSearchRuntime()
  const view = buildGlobalSearchView(runtime)
  const actions = bindGlobalSearchActions(runtime, view)

  return {
    query: runtime.query,
    results: runtime.results,
    stats: runtime.stats,
    status: runtime.status,
    panelOpen: runtime.panelOpen,
    scopeTypes: runtime.scopeTypes,
    scopeRefetching: runtime.scopeRefetching,
    trimmedQuery: view.trimmedQuery,
    hasMinimumQuery: view.hasMinimumQuery,
    availableScopeTypes: view.availableScopeTypes,
    resultFilterTypes: view.resultFilterTypes,
    groupedResults: view.groupedResults,
    topResults: view.topResults,
    flatSelectableResults: view.flatSelectableResults,
    showFeedbackPrompt: view.showFeedbackPrompt,
    feedbackAlreadySubmitted: view.feedbackAlreadySubmitted,
    ...actions,
  }
}
